import * as _ from "lodash";
import { put, select } from "redux-saga/effects";

import actions from "@/actions";

/**
 * Copies the currently selected lights to the clipboard.
 *
 * @yields Selects current lights and dispatches clipboard update.
 */
function* copy() {
    try {
        const selectedLights = yield select((state) =>
            _.filter(
                state.map.values.mode.present.lights,
                (light) => light.selected,
            ),
        );
        yield put(actions.map.general.setClipboard(selectedLights));
        yield put(
            actions.window.showMessage(
                "Lights have been copied to the clipboard. You can move the screen around as needed. When you’re ready to paste, hit the “Paste” button and select a location.",
                "success",
            ),
        );
    } catch (err) {
        // eslint-disable-next-line no-console
        console.log("err on copy lights:", err);
    }
}

export default copy;
